import React from 'react';
import { Segmented } from 'antd';
import './page.css';

/** View toggle / chip filter: antd Segmented at the default size, so every page looks the same. */
const PageFilter = ({ className = '', size, ...rest }) => (
  <div className="pl-page-filter">
    <Segmented className={className} {...rest} />
  </div>
);

export default PageFilter;
